import React, { useContext } from "react"

import Button from "src/components/Button"
import Chips from "src/components/Chips"

import { ManageItemsContext } from "./ManageItemsContainer"

const ManageItemsFilters = () => {
  const {
    selectedCategories,
    handleCategoryFilterSelection,
    searchTerm,
    handleResetFilters,
    includeInactive,
    setIncludeInactive,
    missingBarcode,
    setMissingBarcode,
  } = useContext(ManageItemsContext)

  return (
    <Chips>
      {selectedCategories.map((sc) => (
        <Chips.Chip
          key={sc.id}
          text={sc.displayName}
          onClick={() => handleCategoryFilterSelection(sc)}
        />
      ))}
      {includeInactive && (
        <Chips.Chip
          key="inactive_items"
          text="Show inactive items"
          onClick={() => setIncludeInactive(false)}
        />
      )}
      {missingBarcode && (
        <Chips.Chip
          key="missing_barcode"
          text="No Barcode"
          onClick={() => setMissingBarcode(false)}
        />
      )}
      <Button
        variant="ghost"
        small
        onClick={handleResetFilters}
        disabled={
          selectedCategories.length === 0 &&
          searchTerm.length === 0 &&
          !includeInactive &&
          !missingBarcode
        }
      >
        Clear all filters
      </Button>
    </Chips>
  )
}

export default ManageItemsFilters
